import Report from '@mui/icons-material/Report';
import { Typography } from '@mui/material';
import { orange } from '@mui/material/colors';
import { inject, observer } from 'mobx-react';
import ReactComponent from './ReactComponent';

class TelaUsuarioSemAutorizacaoAcesso extends ReactComponent {
    render() {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: '1',
                    alignItems: 'center',
                    padding: '2em'
                }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <>
                        <Report style={{ width: '96px', height: '96px', fill: orange[800] }} />
                        <Typography style={{ fontSize: 'larger', fontWeight: 'bold', color: orange[800] }}>
                            USUÁRIO SEM AUTORIZAÇÃO DE ACESSO
                        </Typography>
                        <Typography style={{ color: orange[800], fontStyle: 'italic' }}>
                            Contacte o administrador do sistema para solicitar acesso ao recurso desejado.
                        </Typography>
                    </>
                </div>
            </div>
        );
    }
}

export default inject('stores')(observer(TelaUsuarioSemAutorizacaoAcesso));
